<div *ngIf="isOpen" class="address-pick-wrap" [@fadeInOut]>
	<div>
		<div *ngFor="let addr of addresses; let idx = index;" class="same-line">
			<input type="checkbox" name="addr{{idx}}" [(ngModel)]="addr.isChecked">
			<div>{{addr.label}}</div>
		</div>
	</div>
	<div class="button-line">
		<button class="" (click)="clickOk()">ok</button>
	</div>
</div>

